import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Card, Container, Paper, Typography, makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import FondoGradiante from 'assets/images/FondoGradiante.png';
import clsx from 'clsx';
const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
    },
    wrapper: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: 64,
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 256
        }
    },
    wrapper2: {
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingTop: 64
    },
    contentContainer: {
        position: 'relative',
        display: 'flex',
        flex: '1 1 auto',
        overflow: 'hidden',
        height: '100%',
        overflow: '     ',
        background: '#ececec'
    },
    content: {
        position: 'relative',
        flex: '1 1 auto'
    },
    footer: {
        textAlign: 'right',
        bottom: 0,
        right: 0
    },
    backGradiante: {
        position: 'absolute',
        backgroundImage: `url( ${FondoGradiante})`,
        width: '100%',
        height: '250px'
    },
    backGradianteAjuste: {
        width: '100%'
    }
}));

const DashboardLayout = ({ rutas, usuario }) => {
    const classes = useStyles();
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);
    const [openDesktop, setOpenDesktop] = useState(true);

    const cambioMenuDeskTop = () => {
        setOpenDesktop(!openDesktop);
    };

    useEffect(() => {
        //ServiciosUser.info(setInfo,()=>{});
    }, []);
    return (
        <div className={classes.root}>
            <TopBar
                onMobileNavOpen={() => setMobileNavOpen(true)}
                openNavDesktop={openDesktop}
                onOpenNavDesktop={cambioMenuDeskTop}
                usuario={usuario}
            />
            <NavBar
                onMobileClose={() => setMobileNavOpen(false)}
                openDesktop={openDesktop}
                openMobile={isMobileNavOpen}
                info={{ rutas: rutas }}
            />
            <div className={openDesktop ? classes.wrapper : classes.wrapper2}>
                <div className={classes.contentContainer}>
                    {/* <div className={clsx(classes.backGradiante, !openDesktop ? classes.backGradianteAjuste : null)}>
                        <Paper
                            style={{
                                position: 'absolute',
                                top: '50px',
                                width: '98%',
                                marginLeft: '1%',
                                height: '200px',
                                background: '#f8f8f8'
                            }}
                        />
                    </div> */}
                    <div className={classes.content}>
                        <div
                            style={{
                                position: 'absolute',
                                width: '100%',
                                paddingLeft: '3%',
                                paddingRight: '3%',
                                paddingTop: '75px',
                                minHeight: '100%',
                                flexDirection: 'column',
                                display: 'flex'
                            }}
                        >
                            <Outlet />
                            <Typography className={classes.footer} variant="body1" style={{ color: '#7b7f82', marginTop: 'auto' }}>
                                © {new Date().getFullYear()}
                                <a href="https://ciudadmaderas.com" target="_blank" style={{ color: '#3c8dbc', display: 'inline-block' }}>
                                    Ciudad Maderas
                                </a>
                                . Departamento de TI
                            </Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;
